<script> 
	import { 
		headerTitleHome, 
		linkAV,
		linkConheca,
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkInstagram,
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Vitrine          		from '../components/Vitrine.svelte'
	import ListaImoveis    			from '../components/ListaImoveis.svelte'
	import Busca					from '../components/Busca.svelte'
	import Instagram				from '../components/Instagram.svelte'
	import Blog						from '../components/Blog.svelte'

	import Boleto           		from '../components/Boleto.svelte'
	import PossoAjudar 				from '../components/PossoAjudar.svelte'
	import PopUp					from '../components/PopUp.svelte'

	let vitrines = [
		{
			image: 'home1.jpg', 
			imageMobile: 'home1M.png', 
			title: 'Vendas',
			href: $linkPesquisaVendas
		},
		{
			image: 'home2.jpg', 
			imageMobile: 'home2M.png', 
			title: 'Condomínios',
			href: '/administracao-condominios'
		}
	];
	let vitrines2 = [
		{
			image: 'home_desktop_rodape_1.jpg', 
			imageMobile: 'home_rodape_1.png', 
			title: 'Imóveis',
			href: $linkPesquisaVendas
		},
		{
			image: 'home_desktop_rodape_2.jpg', 
			imageMobile: 'home_rodape_2.png', 
			title: 'Seguro',
			href: '/seguro-conteudo'
		}
	];
	
	/* Imóveis */ 
	function search(e) {
		const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(e.detail).filter(p=>p[1].toString().length>0&&p[1].toString()!='0').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}
	
	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1};
	let filtrosDestaquesVendas = {nt:8, tipo_negociacao:8, pageSize:6, random: 1, codigo: '-FR'};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: true,
				dots: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			});
		}, 500);
	}
	function toggleMenu() {
		document.querySelector('header.header--hidden').classList.toggle('hidden');
	}

	let selectedNegotiationType = 8;
	function changeNegotiationType(nt) {
		selectedNegotiationType = nt;
	}

	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<Vitrine vitrines={vitrines} showDots={false} vitrineHeight="460px"/>

<section class="section busca busca--home">
	<div class="container container-short pb-40">
		<div class="pb-10 text-left">
			<h3 class="color-white mb-0 text-bold">Como podemos ajudar?</h3>
		</div>
		<div class="background-white round-all pl-30 pr-30 pt-0 pb-0">
			<div class="tabs">
				<a class="{selectedNegotiationType == 1 ? 'on' : ''}" on:click={()=>changeNegotiationType(atria.rent)}>Alugar</a>
				<a class="{selectedNegotiationType == 8 ? 'on' : ''}" on:click={()=>changeNegotiationType(atria.sell)}>Comprar</a>
				<a href="/administracao-condominios">Condomínios</a>
			</div>
			<Busca on:filter={search} selectedNegotiationType={selectedNegotiationType} style="home" buttonClass="btn-tertiary" />
		</div>
	</div>
</section>

<!--Links-->
<section class="section section-links">
	<div class="container">
		<div class="itens flex flex-center flex-wrap">
			<a href="{$linkPesquisaLocacao}" use:link replace>
				<i class="fas fa-hand-holding-usd"></i>
				<h3 class="subtitle">Imóveis<br class="hidden-sm hidden-xs "/> alugar</h3>
			</a>
			<a href="{$linkPesquisaVendas}" use:link replace>
				<i class="fas fa-key"></i>
				<h3 class="subtitle">Compra<br class="hidden-sm hidden-xs "/> e venda</h3>
			</a>
			<a href="/administracao-condominios" use:link replace>
				<i class="fas fa-building"></i>
				<h3 class="subtitle">Gestão<br class="hidden-sm hidden-xs "/> condominial</h3>
			</a>
			<a href="/seguro-conteudo" use:link replace>
				<i class="fas fa-shield-alt"></i>
				<h3 class="subtitle">Seguro<br class="hidden-sm hidden-xs "/> conteúdo</h3>
			</a>
		</div>
	</div>
</section>

<Vitrine vitrines={vitrines2} showDots={true} vitrineHeight="460px"/>

<!-- Destaques Comprar -->
<section class="section destaques-home destaques-home--vendas background-dark-gray">
	<div class="container">
		<div class="header">
			<h2 class="title">
				<a href="{$linkPesquisaVendas}">Imóveis para comprar</a>
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
		<div class="flex flex-center pt-20 pb-20">
			<a class="btn btn-tertiary btn-bold" href="{$linkPesquisaVendas}">VER MAIS</a>
		</div>
	</div>
</section>

<!-- Destaques Alugar -->
<section class="section destaques-home destaques-home--locacao background-gray">
	<div class="container">
		<div class="header">
			<h2 class="title">
				<a href="{$linkPesquisaLocacao}">Imóveis para alugar</a>
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
		<div class="flex flex-center pt-20 pb-20">
			<a class="btn btn-tertiary btn-bold" href="{$linkPesquisaLocacao}">VER MAIS</a>
		</div>
	</div>
</section>

<Blog />
<Boleto />
<PopUp channel="site" />